import { useBiddingDispatch } from './bidding-context';
import PortalAppService from '../../../application/platform/portal-app-service';
import BaseAppService from '../../../application/platform/base-app-service';
import { IListBiddingRequest } from '../../../model/base/request/list-bidding-request';

export function useBiddingController() {
  const dispatch = useBiddingDispatch();

  const loadData = async (params: IListBiddingRequest) => {
    dispatch({ type: 'LOAD_START' });

    try {
      const response = await PortalAppService.listBidding(params);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar licitações';
      dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
    }
  };

  const loadModalities = async () => {
    dispatch({ type: 'LOAD_MODALITIES_START' });

    try {
      const response = await BaseAppService.getListModalityBidding();
      dispatch({ type: 'LOAD_MODALITIES_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar modalidades';
      dispatch({ type: 'LOAD_MODALITIES_ERROR', payload: errorMessage });
    }
  };

  return {
    loadData,
    loadModalities,
  };
}
